import { EnvironmentInterface } from '../app/core/interfaces';

export const environment: EnvironmentInterface = {
  isProduction: false,
  apiBaseUrl: "https://api.dev.werfy.io",
};
